import { render, staticRenderFns } from "./cost_file.vue?vue&type=template&id=06e56f44&scoped=true"
import script from "./cost_file.vue?vue&type=script&lang=js"
export * from "./cost_file.vue?vue&type=script&lang=js"
import style0 from "./cost_file.vue?vue&type=style&index=0&id=06e56f44&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e56f44",
  null
  
)

export default component.exports